import { m8API } from 'services/production/m8';
import { ChangePartnerBlockService } from 'types/services';

export const changePartnerBlock: ChangePartnerBlockService = async (
  blocked,
  partnerId
) => {
  await m8API.admin.setPartnerBlocking({
    idPartner: partnerId,
    blocking: blocked,
  });
};
